define('adminUserGroupsListView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'jquery',
  'windows',
  'tableView',
  'tableFieldView',
  'adminUserGroupsListHeaderToolsView',
  'adminUserGroupsListRowToolsView',
  'adminUserGroupsEditPopupView',
  'entities/admin/user_groups'
], function (
  Module,
  App,
  Backbone,
  _,
  $,
  Windows,
  TableView,
  FieldView,
  HeaderToolsView,
  RowToolsView,
  EditPopupView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'admin-user-groups-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',

    onBeforeShow: function () {
      if (TableView.prototype.onBeforeShow) {
        TableView.prototype.onBeforeShow.apply(this, arguments);
      }
      // Prime the shared canEdit flag on App so row / header tools can read it
      // at click time. We intentionally don't try to cache it on this view and
      // pass it down — the async nature means the initial render always sees
      // "false" and we don't want a stale snapshot locked into a subclass.
      App.userGroupsCanEdit = false;
      App.request('userGroups:canEdit').done(function (canEdit) {
        App.userGroupsCanEdit = canEdit === true;
      });
    },

    setFields: function () {
      return [{
        name: 'Name',
        label: _.i18n('common.name'),
        className: 'name',
        bind: 'name',
        modelEvent: 'change:name'
      }, {
        name: 'MemberCount',
        label: _.i18n('admin.userGroups.memberCount'),
        className: 'member-count',
        bind: 'memberCount',
        modelEvent: 'change:memberCount change:members'
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView,
        headerView: HeaderToolsView
      }];
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();

      var params = {
        first: first,
        pageSize: pageSize
      };

      if (this.fetchRequest) {
        this.fetchRequest.abort();
      }

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('userGroups:get-url', params),
        success: _.bind(function (items) {
          if (!items || items.length === 0) {
            defer.resolve([]);
            return;
          }
          // The list endpoint returns the shallow DTO (no members), so fetch
          // member counts per row. For admin-scale traffic the extra round-trips
          // are negligible.
          var promises = _.map(items, function (item) {
            return App.request('userGroups:get', item.secId).then(function (details) {
              var members = (details && details.members) || [];
              return App.request('userGroups:model', {
                secId: item.secId,
                name: item.name,
                members: members,
                memberCount: members.length
              });
            });
          });

          $.when.apply($, promises).then(function () {
            var models = _.toArray(arguments);
            defer.resolve(models);
          });
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();

      if (this.fetchCountRequest) {
        this.fetchCountRequest.abort();
      }

      this.fetchCountRequest = $.ajax({
        url: App.request('userGroups:row-count-url', {}),
        success: function (resp) { defer.resolve(resp); }
      });

      return defer.promise();
    },

    onRowClick: function (rowView) {
      // Re-read the canEdit flag at click time so the popup opens in the
      // correct mode even if the initial canEdit fetch raced with render.
      var bodyView = this.bodyView;
      var secId = rowView.model.get('secId');
      App.request('userGroups:canEdit').done(function (canEdit) {
        var isEdit = canEdit === true;
        App.userGroupsCanEdit = isEdit;
        Windows.open({
          view: function () {
            return new EditPopupView({
              groupSecId: secId,
              canEdit: isEdit,
              onConfirm: function () {
                bodyView.fetch();
              }
            });
          },
          title: isEdit ? _.i18n('admin.userGroups.editMembers') : _.i18n('admin.userGroups.viewMembers'),
          width: 560,
          height: 620,
          modal: true
        });
      });
    }
  });
});

